import { render, staticRenderFns } from "./OrgExists.vue?vue&type=template&id=ef7899a6&scoped=true&"
import script from "./OrgExists.vue?vue&type=script&lang=js&"
export * from "./OrgExists.vue?vue&type=script&lang=js&"
import style0 from "./OrgExists.vue?vue&type=style&index=0&id=ef7899a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7899a6",
  null
  
)

export default component.exports